import { render, staticRenderFns } from "./AstralImportPage.vue?vue&type=template&id=7564d571"
import script from "./AstralImportPage.vue?vue&type=script&lang=js"
export * from "./AstralImportPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports